module.exports = __webpack_public_path__ + "img/food_intro1_opt.efc7e807.jpg";